<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 8 14"
>
  <path d="M7 1.5L2 7L7 12.5" stroke="#91A7AE" stroke-width="2"/>
</svg>
